const DEFAULT_RELATED_ADS = []

export const getInitialRelatedAdsProps = ({i18n, domain, vehicles}) => {
  const domainConfig = domain.get('config')
  const [articleVehicle] = vehicles
  if (!articleVehicle) return Promise.resolve(DEFAULT_RELATED_ADS)

  const tenant = domainConfig.get('TENANT')

  const requestBasedOnTenant = {
    coches: {
      request: () => cochesRequester({domain, articleVehicle}),
      adapt: response => cochesAdapter({domain, i18n, response, articleVehicle})
    },

    motos: {
      request: () => motosRequester({domain, articleVehicle}),
      adapt: response => motosAdapter({domain, i18n, response, articleVehicle})
    }
  }

  return Promise.allSettled(requestBasedOnTenant[tenant].request()).then(requestBasedOnTenant[tenant].adapt)
}

function cochesRequester() {
  return Promise.resolve([null, null])
}

function cochesAdapter() {
  return {
    items: [],
    relatedAdsCollectionTitle: null
  }
}

function motosRequester({domain, articleVehicle}) {
  const domainConfig = domain.get('config')
  const {DEFAULT_SEARCH, OFFER_TYPE_SECOND_HAND, OFFER_TYPE_NEW} = domainConfig.get('search')
  const {SELLER_TYPE_PROFESSIONAL} = domainConfig.get('dealer')
  const hasModel = Boolean(articleVehicle.model)

  const commonParams = {
    ...DEFAULT_SEARCH,
    makeId: Number(articleVehicle.make.id),
    sellerTypeId: SELLER_TYPE_PROFESSIONAL,
    hasPhoto: true,
    page: 1,
    model: hasModel && {id: Number(articleVehicle.model.id)}
  }
  const ocasionAdsSearch = {
    ...commonParams,
    filteredOfferTypeId: OFFER_TYPE_SECOND_HAND
  }

  const newAdsSearch = {
    ...commonParams,
    filteredOfferTypeId: OFFER_TYPE_NEW
  }

  return [
    domain.get('get_search_results_ads_use_case').execute(ocasionAdsSearch),
    domain.get('get_search_results_ads_use_case').execute(newAdsSearch)
  ]
}

function motosAdapter({domain, i18n, response, articleVehicle}) {
  const domainConfig = domain.get('config')
  const {MAX_RELATED_ADS} = domainConfig.get('editorial')
  const titlesMap = {
    0: i18n.t('NEWS.DETAIL_RELATED_ADS_TITLE_SECOND_HAND', getPlaceholders({articleVehicle})),
    1: i18n.t('NEWS.DETAIL_RELATED_ADS_TITLE_NEW_MOTOS', getPlaceholders({articleVehicle}))
  }

  return mapAdsCollection(response)({
    titlesMap,
    maxAmountOfRelatedAds: MAX_RELATED_ADS
  })
}

function mapAdsCollection(response) {
  return ({titlesMap, maxAmountOfRelatedAds}) => {
    return response
      .map((adsCollectionResponse, index) => {
        const {
          value: [relatedAdsError, relatedAdsSuccess]
        } = adsCollectionResponse

        if (relatedAdsError || !relatedAdsSuccess.items.length) return null
        return {
          items: relatedAdsSuccess.items.slice(0, maxAmountOfRelatedAds),
          relatedAdsCollectionTitle: titlesMap[index]
        }
      })
      .filter(isNotNullish => isNotNullish)
  }
}

function getPlaceholders({articleVehicle}) {
  const {make, model} = articleVehicle
  return {
    make: make.name,
    model: model && model.name ? model.name : ''
  }
}
